module.exports = __webpack_public_path__ + "static/media/lupins.12a36ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/lupins.svg
// module id = 1130
// module chunks = 0